declare namespace $ {

	type $mol_view__sub_bog_music_player_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_music_player_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__title_bog_music_player_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_bog_music_player_4 = $mol_type_enforce<
		ReturnType< $bog_music_player['missing_pull'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_bog_music_player_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__style_bog_music_player_6 = $mol_type_enforce<
		({ 
			'width': ReturnType< $bog_music_player['progress_width'] >,
		}) 
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__style_bog_music_player_7 = $mol_type_enforce<
		({ 
			'left': ReturnType< $bog_music_player['progress_width'] >,
		}) 
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__event_bog_music_player_8 = $mol_type_enforce<
		({ 
			pointerdown( next?: ReturnType< $bog_music_player['trim_start_pointer_down'] > ): ReturnType< $bog_music_player['trim_start_pointer_down'] >,
			pointermove( next?: ReturnType< $bog_music_player['trim_start_pointer_move'] > ): ReturnType< $bog_music_player['trim_start_pointer_move'] >,
			pointerup( next?: ReturnType< $bog_music_player['trim_pointer_up'] > ): ReturnType< $bog_music_player['trim_pointer_up'] >,
			pointercancel( next?: ReturnType< $bog_music_player['trim_pointer_up'] > ): ReturnType< $bog_music_player['trim_pointer_up'] >,
		}) 
		,
		ReturnType< $mol_view['event'] >
	>
	type $mol_view__style_bog_music_player_9 = $mol_type_enforce<
		({ 
			'left': ReturnType< $bog_music_player['trim_start_left'] >,
		}) 
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__event_bog_music_player_10 = $mol_type_enforce<
		({ 
			pointerdown( next?: ReturnType< $bog_music_player['trim_end_pointer_down'] > ): ReturnType< $bog_music_player['trim_end_pointer_down'] >,
			pointermove( next?: ReturnType< $bog_music_player['trim_end_pointer_move'] > ): ReturnType< $bog_music_player['trim_end_pointer_move'] >,
			pointerup( next?: ReturnType< $bog_music_player['trim_pointer_up'] > ): ReturnType< $bog_music_player['trim_pointer_up'] >,
			pointercancel( next?: ReturnType< $bog_music_player['trim_pointer_up'] > ): ReturnType< $bog_music_player['trim_pointer_up'] >,
		}) 
		,
		ReturnType< $mol_view['event'] >
	>
	type $mol_view__style_bog_music_player_11 = $mol_type_enforce<
		({ 
			'left': ReturnType< $bog_music_player['trim_end_left'] >,
		}) 
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__event_bog_music_player_12 = $mol_type_enforce<
		({ 
			pointerdown( next?: ReturnType< $bog_music_player['seek_pointer_down'] > ): ReturnType< $bog_music_player['seek_pointer_down'] >,
			pointermove( next?: ReturnType< $bog_music_player['seek_pointer_move'] > ): ReturnType< $bog_music_player['seek_pointer_move'] >,
			pointerup( next?: ReturnType< $bog_music_player['seek_pointer_up'] > ): ReturnType< $bog_music_player['seek_pointer_up'] >,
			pointercancel( next?: ReturnType< $bog_music_player['seek_pointer_up'] > ): ReturnType< $bog_music_player['seek_pointer_up'] >,
		}) 
		,
		ReturnType< $mol_view['event'] >
	>
	type $mol_view__sub_bog_music_player_13 = $mol_type_enforce<
		ReturnType< $bog_music_player['progress_parts'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_music_player_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_music_player_15 = $mol_type_enforce<
		ReturnType< $bog_music_player['time_current_text'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_bog_music_player_16 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_bog_music_player_17 = $mol_type_enforce<
		ReturnType< $bog_music_player['time_total_text'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_bog_music_player_18 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_image__uri_bog_music_player_19 = $mol_type_enforce<
		ReturnType< $bog_music_player['cover'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_paragraph__title_bog_music_player_20 = $mol_type_enforce<
		ReturnType< $bog_music_player['title'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_music_player_21 = $mol_type_enforce<
		ReturnType< $bog_music_player['artist'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_bog_music_player_22 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__event_bog_music_player_23 = $mol_type_enforce<
		({ 
			click( next?: ReturnType< $bog_music_player['open'] > ): ReturnType< $bog_music_player['open'] >,
		}) 
		,
		ReturnType< $mol_view['event'] >
	>
	type $mol_view__sub_bog_music_player_24 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__click_bog_music_player_25 = $mol_type_enforce<
		ReturnType< $bog_music_player['prev'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_music_player_26 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__hint_bog_music_player_27 = $mol_type_enforce<
		ReturnType< $bog_music_player['toggle_hint'] >
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_music_player_28 = $mol_type_enforce<
		ReturnType< $bog_music_player['toggle'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_music_player_29 = $mol_type_enforce<
		ReturnType< $bog_music_player['toggle_icons'] >
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_bog_music_player_30 = $mol_type_enforce<
		ReturnType< $bog_music_player['next'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_music_player_31 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_bog_music_player_32 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__hint_bog_music_player_33 = $mol_type_enforce<
		ReturnType< $bog_music_player['repeat_hint'] >
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_music_player_34 = $mol_type_enforce<
		ReturnType< $bog_music_player['repeat_cycle'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_music_player_35 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_check_icon__hint_bog_music_player_36 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_icon['hint'] >
	>
	type $mol_check_icon__Icon_bog_music_player_37 = $mol_type_enforce<
		ReturnType< $bog_music_player['Trim_icon'] >
		,
		ReturnType< $mol_check_icon['Icon'] >
	>
	type $mol_check_icon__checked_bog_music_player_38 = $mol_type_enforce<
		ReturnType< $bog_music_player['trim_mode'] >
		,
		ReturnType< $mol_check_icon['checked'] >
	>
	type $mol_button_minor__hint_bog_music_player_39 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_music_player_40 = $mol_type_enforce<
		ReturnType< $bog_music_player['eq_pop_toggle'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_music_player_41 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $bog_music_eq_curve__gains_bog_music_player_42 = $mol_type_enforce<
		ReturnType< $bog_music_player['eq_gains'] >
		,
		ReturnType< $bog_music_eq_curve['gains'] >
	>
	type $bog_music_eq_curve__pointer_down_bog_music_player_43 = $mol_type_enforce<
		ReturnType< $bog_music_player['eq_pointer_down'] >
		,
		ReturnType< $bog_music_eq_curve['pointer_down'] >
	>
	type $bog_music_eq_curve__pointer_move_bog_music_player_44 = $mol_type_enforce<
		ReturnType< $bog_music_player['eq_pointer_move'] >
		,
		ReturnType< $bog_music_eq_curve['pointer_move'] >
	>
	type $bog_music_eq_curve__pointer_up_bog_music_player_45 = $mol_type_enforce<
		ReturnType< $bog_music_player['eq_pointer_up'] >
		,
		ReturnType< $bog_music_eq_curve['pointer_up'] >
	>
	type $mol_check_icon__title_bog_music_player_46 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_icon['title'] >
	>
	type $mol_check_icon__hint_bog_music_player_47 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_icon['hint'] >
	>
	type $mol_check_icon__Icon_bog_music_player_48 = $mol_type_enforce<
		ReturnType< $bog_music_player['Eq_power_icon'] >
		,
		ReturnType< $mol_check_icon['Icon'] >
	>
	type $mol_check_icon__checked_bog_music_player_49 = $mol_type_enforce<
		ReturnType< $bog_music_player['eq_on'] >
		,
		ReturnType< $mol_check_icon['checked'] >
	>
	type $mol_check__title_bog_music_player_50 = $mol_type_enforce<
		ReturnType< $bog_music_player['eq_preset_title'] >
		,
		ReturnType< $mol_check['title'] >
	>
	type $mol_check__checked_bog_music_player_51 = $mol_type_enforce<
		ReturnType< $bog_music_player['eq_preset_checked'] >
		,
		ReturnType< $mol_check['checked'] >
	>
	type $mol_view__sub_bog_music_player_52 = $mol_type_enforce<
		ReturnType< $bog_music_player['eq_preset_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_music_player_53 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_pop__Anchor_bog_music_player_54 = $mol_type_enforce<
		ReturnType< $bog_music_player['Eq_anchor'] >
		,
		ReturnType< $mol_pop['Anchor'] >
	>
	type $mol_pop__bubble_content_bog_music_player_55 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pop['bubble_content'] >
	>
	type $mol_button_minor__hint_bog_music_player_56 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_music_player_57 = $mol_type_enforce<
		ReturnType< $bog_music_player['volume_toggle'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_music_player_58 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_check_icon__hint_bog_music_player_59 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_icon['hint'] >
	>
	type $mol_check_icon__Icon_bog_music_player_60 = $mol_type_enforce<
		ReturnType< $bog_music_player['Norm_icon'] >
		,
		ReturnType< $mol_check_icon['Icon'] >
	>
	type $mol_check_icon__checked_bog_music_player_61 = $mol_type_enforce<
		ReturnType< $bog_music_player['normalize'] >
		,
		ReturnType< $mol_check_icon['checked'] >
	>
	type $mol_view__style_bog_music_player_62 = $mol_type_enforce<
		({ 
			'height': ReturnType< $bog_music_player['volume_fill_height'] >,
		}) 
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__event_bog_music_player_63 = $mol_type_enforce<
		({ 
			pointerdown( next?: ReturnType< $bog_music_player['volume_pointer_down'] > ): ReturnType< $bog_music_player['volume_pointer_down'] >,
			pointermove( next?: ReturnType< $bog_music_player['volume_pointer_move'] > ): ReturnType< $bog_music_player['volume_pointer_move'] >,
			pointerup( next?: ReturnType< $bog_music_player['volume_pointer_up'] > ): ReturnType< $bog_music_player['volume_pointer_up'] >,
			pointercancel( next?: ReturnType< $bog_music_player['volume_pointer_up'] > ): ReturnType< $bog_music_player['volume_pointer_up'] >,
		}) 
		,
		ReturnType< $mol_view['event'] >
	>
	type $mol_view__sub_bog_music_player_64 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_music_player_65 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_pop__align_bog_music_player_66 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pop['align'] >
	>
	type $mol_pop__Anchor_bog_music_player_67 = $mol_type_enforce<
		ReturnType< $bog_music_player['Volume_anchor'] >
		,
		ReturnType< $mol_pop['Anchor'] >
	>
	type $mol_pop__bubble_content_bog_music_player_68 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pop['bubble_content'] >
	>
	type $mol_view__sub_bog_music_player_69 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__hint_bog_music_player_70 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_music_player_71 = $mol_type_enforce<
		ReturnType< $bog_music_player['collapse'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_music_player_72 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__hint_bog_music_player_73 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__click_bog_music_player_74 = $mol_type_enforce<
		ReturnType< $bog_music_player['close'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_bog_music_player_75 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_bog_music_player_76 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_music_player_77 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_music_player extends $mol_view {
		Empty_icon( ): $mol_icon_music
		Empty_text( ): $mol_view
		missing( ): string
		Missing_text( ): $mol_view
		missing_pull( next?: any ): any
		Missing_pull( ): $mol_button_minor
		Missing( ): $mol_view
		seek_pointer_down( next?: any ): any
		seek_pointer_move( next?: any ): any
		seek_pointer_up( next?: any ): any
		Progress_line( ): $mol_view
		progress_width( ): string
		Progress_bar( ): $mol_view
		Progress_knob( ): $mol_view
		trim_start_pointer_down( next?: any ): any
		trim_start_pointer_move( next?: any ): any
		trim_pointer_up( next?: any ): any
		trim_start_left( ): string
		Trim_start_handle( ): $mol_view
		trim_end_pointer_down( next?: any ): any
		trim_end_pointer_move( next?: any ): any
		trim_end_left( ): string
		Trim_end_handle( ): $mol_view
		progress_parts( ): readonly(any)[]
		Progress( ): $mol_view
		Progress_row( ): $mol_view
		time_current_text( ): string
		Time_current( ): $mol_paragraph
		trim_hint( ): string
		Trim_hint( ): $mol_view
		time_total_text( ): string
		Time_total( ): $mol_paragraph
		Time_row( ): $mol_view
		open( next?: any ): any
		Cover( ): $mol_image
		Cover_placeholder( ): $mol_icon_music
		title( ): string
		Title( ): $mol_paragraph
		artist( ): string
		Artist( ): $mol_paragraph
		Track_info( ): $mol_view
		Left( ): $mol_view
		prev( next?: any ): any
		Prev_icon( ): $mol_icon_skip_previous
		Prev( ): $mol_button_minor
		toggle_hint( ): string
		toggle( next?: any ): any
		Play_icon( ): $mol_icon_play
		Pause_icon( ): $mol_icon_pause
		toggle_icons( ): readonly(any)[]
		Toggle( ): $mol_button_minor
		next( next?: any ): any
		Next_icon( ): $mol_icon_skip_next
		Next( ): $mol_button_minor
		Center( ): $mol_view
		repeat_hint( ): string
		repeat_cycle( next?: any ): any
		Repeat_all_icon( ): $mol_icon_repeat
		Repeat_one_icon( ): $mol_icon_repeat_once
		Shuffle_icon( ): $mol_icon_shuffle
		Repeat( ): $mol_button_minor
		Trim_icon( ): $mol_icon_content_cut
		trim_mode( next?: boolean ): boolean
		Trim_toggle( ): $mol_check_icon
		eq_pop_toggle( next?: any ): any
		Eq_icon( ): $mol_icon_tune_vertical
		Eq_anchor( ): $mol_button_minor
		eq_gains( ): readonly(number)[]
		eq_pointer_down( next?: any ): any
		eq_pointer_move( next?: any ): any
		eq_pointer_up( next?: any ): any
		Eq_curve( ): $bog_music_eq_curve
		Eq_power_icon( ): $mol_icon_tune_vertical
		eq_on( next?: boolean ): boolean
		Eq_power( ): $mol_check_icon
		eq_preset_title( id: any): string
		eq_preset_checked( id: any, next?: boolean ): boolean
		Eq_preset_row( id: any): $mol_check
		eq_preset_rows( ): readonly(any)[]
		Eq_presets( ): $mol_view
		Eq_panel( ): $mol_view
		Eq( ): $mol_pop
		volume_toggle( next?: any ): any
		Volume_icon( ): $mol_icon_volume_high
		Volume_anchor( ): $mol_button_minor
		Norm_icon( ): $mol_icon_equalizer
		normalize( next?: boolean ): boolean
		Norm( ): $mol_check_icon
		volume_pointer_down( next?: any ): any
		volume_pointer_move( next?: any ): any
		volume_pointer_up( next?: any ): any
		volume_fill_height( ): string
		Volume_fill( ): $mol_view
		Volume_slider( ): $mol_view
		Volume_panel( ): $mol_view
		Volume( ): $mol_pop
		Options( ): $mol_view
		collapse( next?: any ): any
		Collapse_icon( ): $mol_icon_chevron_down
		Collapse( ): $mol_button_minor
		close( next?: any ): any
		Close_icon( ): $mol_icon_close
		Close( ): $mol_button_minor
		Controls( ): $mol_view
		current_key( next?: string ): string
		queue_keys( ): readonly(any)[]
		queue_index( next?: number ): number
		play_track( next?: any ): any
		full( ): boolean
		cover( ): string
		attr( ): ({ 
			'bog_music_player_full': ReturnType< $bog_music_player['full'] >,
		})  & ReturnType< $mol_view['attr'] >
		Empty( ): $mol_view
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=player.view.tree.d.ts.map